import { render, staticRenderFns } from "./VipTips.vue?vue&type=template&id=e02184ae&scoped=true"
import script from "./VipTips.vue?vue&type=script&lang=js"
export * from "./VipTips.vue?vue&type=script&lang=js"
import style0 from "./VipTips.vue?vue&type=style&index=0&id=e02184ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02184ae",
  null
  
)

export default component.exports